import { Cookies } from 'react-cookie';

import { reportSBSMonitoringApiResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getSBSMonitoring = async (slug: string, start_date: string, end_date: string, filter_type: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/srbm_monitoring/${slug}/`, {
    headers: {
      Authorization: token,
    },
    params: {
      start_date,
      end_date,
      filter_type,
    },
  });

  return data.data as reportSBSMonitoringApiResponse;
};
